var $704e90e35332a9cb$exports = {};
$704e90e35332a9cb$exports = {
    "info": `Information`,
    "help": `Help`
};


export {$704e90e35332a9cb$exports as default};
//# sourceMappingURL=en-US.module.js.map
